export default String.raw`
{% assign product = product-presentation.Product %}

{% include 'partials/common/card-product.html' with 'lookbook' -%}
`